<div
	class="flex items-center flex-col gap-6 justify-center"
	[class]="{
		absolute: isAbsolute(),
		'top-1/2': isAbsolute(),
		'left-4': isAbsolute(),
		'right-4': isAbsolute(),
		'translate-x-0': isAbsolute(),
		'-translate-y-2/4': isAbsolute(),
	}"
>
	@if (image()) {
		<img [class]="imageStyles()" [src]="image()" alt="empty-stage-image" />
	}
	@if (text()) {
		@if (notifyType()) {
			<ui-notify [text]="text()" [type]="notifyType()" data-cy="empty-state-message"></ui-notify>
		} @else {
			<p class="max-w-3xl text-center text-secondary-900" data-cy="empty-state-message">
				{{ text() }}
			</p>
		}
	}

	@if (buttonText()) {
		<ui-button
			[href]="buttonHref()"
			[icon]="buttonIcon()"
			[queryParams]="buttonQueryParams()"
			[route]="buttonRoute()"
			[target]="buttonTarget()"
			[text]="buttonText()"
			(buttonClicked)="clicked($event)"
			data-cy="empty-state-button"
		>
		</ui-button>
	}
	<ng-content select="[custom-content]"></ng-content>
</div>
